import { render, staticRenderFns } from "./oldDialog.vue?vue&type=template&id=67d52f09&scoped=true&"
import script from "./oldDialog.vue?vue&type=script&lang=js&"
export * from "./oldDialog.vue?vue&type=script&lang=js&"
import style0 from "./oldDialog.vue?vue&type=style&index=0&id=67d52f09&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d52f09",
  null
  
)

export default component.exports